var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmaha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3232_25481)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#5F5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97936 24.5L8.43136 19.748H9.77116L11.2232 24.5H10.2992L9.00556 20.309H9.17716L7.90336 24.5H6.97936ZM7.85056 23.51V22.6718H10.3586V23.51H7.85056Z",
    fill: "#1A191E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3232_25481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.35 28.9191C11.35 27.7628 9.67944 27.166 9.11564 26.0936L9.09476 26.075L9.08431 26.0936C8.52051 27.166 6.84998 27.7628 6.84998 28.9191C6.84998 29.8889 8.28037 30.2619 8.97991 29.4506C8.99035 29.4133 8.97991 29.7117 8.9277 29.8796C8.76065 30.3738 8.15508 31.1012 7.86274 31.325C8.26993 31.0172 9.90914 31.0172 10.3163 31.325C10.024 31.1012 9.44974 30.4018 9.25137 29.8796C9.2096 29.7304 9.18872 29.5905 9.17828 29.4413C9.86738 30.3178 11.35 29.9075 11.35 28.9191Z",
    fill: "#1A191E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.1499 35.4944C19.1499 33.4131 16.143 32.3389 15.1281 30.4086L15.0905 30.375L15.0717 30.4086C14.0569 32.3389 11.0499 33.4131 11.0499 35.4944C11.0499 37.2401 13.6246 37.9115 14.8838 36.4512C14.9026 36.3841 14.8838 36.9212 14.7898 37.2233C14.4891 38.1129 13.3991 39.4222 12.8729 39.825C13.6058 39.2711 16.5564 39.2711 17.2894 39.825C16.7632 39.4222 15.7295 38.1633 15.3724 37.2233C15.2973 36.9548 15.2597 36.703 15.2409 36.4344C16.4812 38.0122 19.1499 37.2737 19.1499 35.4944Z",
    fill: "#1A191E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3232_25481)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#5F5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9794 24.5L29.4314 19.748H30.7712L32.2232 24.5H31.2992L30.0056 20.309H30.1772L28.9034 24.5H27.9794ZM28.8506 23.51V22.6718H31.3586V23.51H28.8506Z",
    fill: "#1A191E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3232_25481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0999 27.2009C29.3602 25.914 27.475 26.4176 27.475 27.6822C27.475 29.1034 29.4318 29.607 30.088 30.9276L30.0999 30.95L30.1119 30.9276C30.7681 29.607 32.7249 29.1034 32.7249 27.6822C32.7369 26.4176 30.8397 25.914 30.0999 27.2009Z",
    fill: "#1A191E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.0999 32.4018C34.7684 30.0853 31.375 30.9918 31.375 33.268C31.375 35.8263 34.8972 36.7328 36.0785 39.1098L36.0999 39.15L36.1214 39.1098C37.3027 36.7328 40.8249 35.8263 40.8249 33.268C40.8464 30.9918 37.4315 30.0853 36.0999 32.4018Z",
    fill: "#1A191E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3232_25481)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#5F5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8667 24.599C50.4883 24.599 50.1759 24.5022 49.9295 24.3086C49.6853 24.115 49.5115 23.8532 49.4081 23.5232L50.2925 23.312C50.3123 23.433 50.3761 23.5386 50.4839 23.6288C50.5917 23.7168 50.7061 23.7608 50.8271 23.7608C50.9107 23.7608 50.9998 23.7377 51.0944 23.6915C51.1912 23.6453 51.2605 23.5716 51.3023 23.4704C51.3287 23.4066 51.3441 23.3285 51.3485 23.2361C51.3529 23.1437 51.3551 23.037 51.3551 22.916V19.748H52.2659V22.916C52.2659 23.0678 52.2648 23.1998 52.2626 23.312C52.2626 23.4242 52.2516 23.5298 52.2296 23.6288C52.2098 23.7256 52.1691 23.8268 52.1075 23.9324C51.9733 24.1656 51.7984 24.335 51.5828 24.4406C51.3672 24.5462 51.1285 24.599 50.8667 24.599Z",
    fill: "#1A191E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3232_25481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.35 28.9191C53.35 27.7628 51.6794 27.166 51.1156 26.0936L51.0948 26.075L51.0843 26.0936C50.5205 27.166 48.85 27.7628 48.85 28.9191C48.85 29.8889 50.2804 30.2619 50.9799 29.4506C50.9903 29.4133 50.9799 29.7117 50.9277 29.8796C50.7606 30.3738 50.1551 31.1012 49.8627 31.325C50.2699 31.0172 51.9091 31.0172 52.3163 31.325C52.024 31.1012 51.4497 30.4018 51.2514 29.8796C51.2096 29.7304 51.1887 29.5905 51.1783 29.4413C51.8674 30.3178 53.35 29.9075 53.35 28.9191Z",
    fill: "#1A191E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.1499 35.4944C61.1499 33.4131 58.143 32.3389 57.1281 30.4086L57.0905 30.375L57.0717 30.4086C56.0569 32.3389 53.0499 33.4131 53.0499 35.4944C53.0499 37.2401 55.6246 37.9115 56.8838 36.4512C56.9026 36.3841 56.8838 36.9212 56.7898 37.2233C56.4891 38.1129 55.3991 39.4222 54.8729 39.825C55.6058 39.2711 58.5564 39.2711 59.2894 39.825C58.7632 39.4222 57.7295 38.1633 57.3724 37.2233C57.2973 36.9548 57.2597 36.703 57.2409 36.4344C58.4812 38.0122 61.1499 37.2737 61.1499 35.4944Z",
    fill: "#1A191E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3232_25481)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#5F5F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9948 24.5V20.7248L69.1038 21.2726V20.2826L69.9948 19.748H70.9122V24.5H69.9948ZM73.2691 24.599C72.9171 24.599 72.6091 24.5253 72.3451 24.3779C72.0811 24.2305 71.8754 24.0248 71.728 23.7608C71.5806 23.4968 71.5069 23.1888 71.5069 22.8368V21.4112C71.5069 21.0592 71.5806 20.7512 71.728 20.4872C71.8754 20.2232 72.0811 20.0175 72.3451 19.8701C72.6091 19.7227 72.9171 19.649 73.2691 19.649C73.6211 19.649 73.9291 19.7227 74.1931 19.8701C74.4571 20.0175 74.6628 20.2232 74.8102 20.4872C74.9576 20.7512 75.0313 21.0592 75.0313 21.4112V22.8368C75.0313 23.1888 74.9576 23.4968 74.8102 23.7608C74.6628 24.0248 74.4571 24.2305 74.1931 24.3779C73.9291 24.5253 73.6211 24.599 73.2691 24.599ZM73.2691 23.7476C73.4275 23.7476 73.5705 23.7102 73.6981 23.6354C73.8257 23.5606 73.9269 23.4594 74.0017 23.3318C74.0765 23.2042 74.1139 23.0612 74.1139 22.9028V21.3386C74.1139 21.1802 74.0765 21.0372 74.0017 20.9096C73.9269 20.782 73.8257 20.6808 73.6981 20.606C73.5705 20.5312 73.4275 20.4938 73.2691 20.4938C73.1107 20.4938 72.9677 20.5312 72.8401 20.606C72.7125 20.6808 72.6113 20.782 72.5365 20.9096C72.4617 21.0372 72.4243 21.1802 72.4243 21.3386V22.9028C72.4243 23.0612 72.4617 23.2042 72.5365 23.3318C72.6113 23.4594 72.7125 23.5606 72.8401 23.6354C72.9677 23.7102 73.1107 23.7476 73.2691 23.7476Z",
    fill: "#1A191E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3232_25481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0999 27.2009C71.3602 25.914 69.475 26.4176 69.475 27.6822C69.475 29.1034 71.4318 29.607 72.088 30.9276L72.0999 30.95L72.1119 30.9276C72.7681 29.607 74.7249 29.1034 74.7249 27.6822C74.7369 26.4176 72.8397 25.914 72.0999 27.2009Z",
    fill: "#1A191E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.0999 32.4018C76.7684 30.0853 73.375 30.9918 73.375 33.268C73.375 35.8263 76.8972 36.7328 78.0785 39.1098L78.0999 39.15L78.1214 39.1098C79.3027 36.7328 82.8249 35.8263 82.8249 33.268C82.8464 30.9918 79.4315 30.0853 78.0999 32.4018Z",
    fill: "#1A191E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3232_25481",
    x: 1,
    y: 15.8,
    width: 24,
    height: 30.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3232_25481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3232_25481",
    x: 22,
    y: 15.8,
    width: 24,
    height: 30.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3232_25481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3232_25481",
    x: 43,
    y: 15.8,
    width: 24,
    height: 30.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3232_25481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3232_25481",
    x: 64,
    y: 15.8,
    width: 24,
    height: 30.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3232_25481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3232_25481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(6.09998 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3232_25481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(27.1 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3232_25481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(48.1 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3232_25481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(69.1 25.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmaha);
export default __webpack_public_path__ + "static/media/omaha.25bafc5f5d0de24896589ee4494d3353.svg";
export { ForwardRef as ReactComponent };